import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './script/store/index'
import './script/td-h5-hybird-sdk'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// If you use Swiper 6.0.0 or higher
import 'swiper/swiper-bundle.css'

// import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
